import React from "react";
import { useNavigate } from "react-router-dom";

const PhotoCapturePromptModal = ({ 
  isOpen, 
  onClose, 
  contestName, 
  contestCategory 
}) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handlePhotoCapture = () => {
    // Navigate to photo capture page with the contest category pre-selected
    navigate(`/photo-capture?type=${encodeURIComponent(contestCategory)}`);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50 p-4">
      <div className="bg-[#1C1C1E] rounded-lg p-6 w-full max-w-md">
        <div className="flex items-center justify-center mb-4">
          <div className="bg-yellow-500 bg-opacity-20 p-4 rounded-full">
            <svg
              className="w-12 h-12 text-yellow-500"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
          </div>
        </div>

        <h2 className="text-2xl font-bold mb-3 text-center text-[#ceb46a]">
          No Images Found
        </h2>
        
        <p className="text-white mb-2 text-center">
          You don't have any images in the <strong className="text-[#ceb46a]">{contestCategory}</strong> category.
        </p>
        
        <p className="text-gray-400 mb-6 text-center text-sm">
          To join <strong>{contestName}</strong>, you need to capture a photo in this category first.
        </p>

        <div className="bg-gray-800 bg-opacity-50 p-4 rounded-lg mb-6">
          <h3 className="text-white font-semibold mb-2 flex items-center">
            <svg
              className="w-5 h-5 mr-2 text-[#ceb46a]"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            Quick Tip
          </h3>
          <p className="text-gray-300 text-sm">
            After capturing your photo, come back to the contest page to join with your new image.
          </p>
        </div>

        <div className="flex gap-3">
          <button
            onClick={onClose}
            className="flex-1 px-6 py-3 border-2 border-gray-600 rounded-lg text-white hover:bg-gray-800 transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={handlePhotoCapture}
            className="flex-1 px-6 py-3 bg-[#ceb46a] text-black rounded-lg hover:bg-[#b99d55] transition-colors font-semibold flex items-center justify-center gap-2"
          >
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"
              />
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M15 13a3 3 0 11-6 0 3 3 0 016 0z"
              />
            </svg>
            Capture Photo
          </button>
        </div>
      </div>
    </div>
  );
};

export default PhotoCapturePromptModal;

